import React from 'react';
import { Typography, Grid, Box, Avatar, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  accordionHeading: {
    fontSize: "18px",
    fontWeight: "500",
  },
}));


const LinkedInIntegration = () => {
    const classes = useStyles();
        
    return (
      <React.Fragment>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    square="true"
                  >
                    <Typography className={classes.accordionHeading}>
                      <ul className="mb-0">
                        <li>
                          Platform yang didukung
                        </li>
                      </ul>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="pl-35">
                      <div className="d-flex mb-15" style={{width:"65%", justifyContent: "space-between"}}>
                        <div className="d-flex" style={{alignItems: "center"}}>
                          <img src="/js-logo.png" width="35px" style={{borderRadius: "5px"}}/>
                          <span className="reguler">&nbsp; Web</span>
                        </div>
                        <div className="d-flex" style={{alignItems: "center"}}>
                          <img src="/logo192.png" width="35px"/>
                          <span className="reguler">&nbsp; React Js</span>
                        </div>
                        <div className="d-flex" style={{alignItems: "center"}}>
                          <img src="/logo192.png" width="35px"/>
                          <span className="reguler">&nbsp; React Native</span>
                        </div>
                        {/* <div className="d-flex" style={{alignItems: "center"}}>
                          <img src="/ios-logo.png" width="35px"/>
                          <span className="reguler">&nbsp; Ios</span>
                        </div> */}
                      </div>
                      Anda dapat mengizinkan pengguna Anda untuk mendaftar & masuk ke aplikasi web Anda dengan akun Google mereka
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.accordionHeading}>
                      <ul className="mb-0">
                        <li>
                          Prasyarat
                        </li>
                      </ul>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="pl-25">
                      <ul className="mb-0">
                        <li>Anda memerlukan akun <u><a className='text-black' href="https://developer.linkedin.com/">Pengembang LinkedIn</a></u></li>
                        <li>Anda harus menginstall <u><a className='text-black' href="https://quickey-docs.netlify.app/">QuicKey SDK</a></u> ke dalam aplikasi web/mobile Anda</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.accordionHeading}>
                      <ul className="mb-0">
                        <li>
                          Pengaturan LinkedIn
                        </li>
                      </ul>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="pl-25">
                      Setelah menginstall ekstensi 0Auth, Anda sekarang dapat mengaktifkan LinkedIn Login untuk aplikasi QuicKey Anda :
                      <ul className="mb-0">
                        <li>Ikuti pentunjuk LinkedIn untuk <u><a className='text-black' href="https://www.linkedin.com/developers/apps/new">menyiapkan aplikasi </a></u></li>
                        <li>Dapatkan ID Klien <strong>(Client ID)</strong> dan Rahasia Klien <strong>(Client Secret)</strong> OAuth dari <u><a className='text-black' href="https://www.linkedin.com/developers/apps/126817686/auth">dasbor Pengembang LinkedIn</a></u> Anda</li>
                        <li>Buka Dashboard QuicKey Anda</li>
                        <li>Pilih aplikasi QuicKey yang ingin Anda aktifkan Login dengan LinkedIn, atau buat aplikasi baru</li>
                        <li>Arahkan ke Login Sosial dari Sidebar</li>
                        <li>Klik Toggle untuk LinkedIn</li>
                        <li>Masukkan ID Klien dan Rahasia Klien untuk aplikasi 0Auth Anda</li>
                        <li>Salin bidang Redirect URI dari Magic Dashboard Anda dan tambahkan ke konfigurasi aplikasi 0Auth Google Dashboard Anda</li>
                        <img width="100%" src="/paste-redirect-uri-linkedin.png" alt="detail linkedin step"/>
                        <li>Di Dasboard QuicKey. Klik "Simpan" - Selesai!</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
    </React.Fragment>
  )
}

export default LinkedInIntegration
